import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const NoPaddingButtonSmall = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"noPadding Small error button"}
        value={
          '<Button variant={"noPadding"} size={\'small\'} color={"error"}>Small</Button>'
        }
      >
        <Button variant={"noPadding"} size={"small"} color={"error"}>
          Small
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default NoPaddingButtonSmall;
